"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Svg_1 = __importDefault(require("./Svg"));
var hooks_1 = require("../hooks");
var CheckActive = function (_a) {
    var color = _a.color, rest = __rest(_a, ["color"]);
    var theme = hooks_1.useTheme();
    return (react_1["default"].createElement(Svg_1["default"], __assign({ width: "18px", height: "18px", viewBox: "0 0 18 18", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, rest),
        react_1["default"].createElement("g", { id: "Simplified-registration", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            react_1["default"].createElement("g", { id: "Simplified-Reg-V3-Filled-calendar", transform: "translate(-476.000000, -499.000000)", fill: color || theme.colors.primary },
                react_1["default"].createElement("g", { id: "checkboxes/active", transform: "translate(476.000000, 499.000000)" },
                    react_1["default"].createElement("path", { d: "M2.99253976,0 L15.0074602,0 C16.6470745,0 18,1.33980569 18,2.99253976 L18,15.0074602 C18,16.6470745 16.6601943,18 15.0074602,18 L2.99253976,18 C1.35292554,18 0,16.6601943 0,15.0074602 L0,2.99253976 C0,1.35292554 1.33980569,0 2.99253976,0 Z M7,14 L16,5.34615385 L14.6,4 L7,11.3076923 L3.4,7.84615385 L2,9.19230769 L7,14 Z", id: "Checkbox-active" }))))));
};
exports["default"] = CheckActive;
//# sourceMappingURL=CheckActive.js.map